import { RouteLocationNormalized, NavigationGuardNext, RouteRecordRaw } from 'vue-router';
import { usePromotionStore } from '@customer/stores/promotion';

const promotionChildGuard = (to: RouteLocationNormalized, from: RouteLocationNormalized, next: NavigationGuardNext) => {
	if (from.name && usePromotionStore().cartPromotions.length) {
		next();
	} else {
		next('/konto/profil/promowanie');
	}
};

const offersChildGuard = (to: RouteLocationNormalized, from: RouteLocationNormalized, next: NavigationGuardNext) => {
	if (from.name) {
		next();
	} else {
		next('/konto/profil/oferty');
	}
};

export default [
	{
		path: '/konto/profil/opinie/wyslij',
		redirect: '/konto/profil/opinie',
	},
	{
		path: '/konto/profil',
		name: 'CustomerProfile',
		component: () => import('@customer/profile/CustomerProfileView.vue'),
		beforeEnter: (to: RouteLocationNormalized, from: RouteLocationNormalized, next: NavigationGuardNext) => {
			const isChildRoute = to.matched.some((routeRecord) => routeRecord.path.includes('/konto/profil/'));
			const isMobile = window.matchMedia('(max-width: 991px)').matches;
			const hasQueryParams = Object.keys(to.query).length;

			if (!isMobile && !isChildRoute) {
				// Jeżeli jesteśmy na desktopie, przekieruj od razu na informacje
				next('/konto/profil/informacje');
			} else if (hasQueryParams) {
				next(to.path);
			} else {
				next();
			}
		},
		children: [
			{
				path: 'promowanie',
				name: 'CustomerProfilePromotion',
				component: () => import('@customer/profile/promotion/PromotionPage.vue'),
				children: [
					{
						name: 'PromotionSummary',
						path: 'podsumowanie',
						component: () => import('@customer/profile/promotion/PromotionSummary.vue'),
						beforeEnter: promotionChildGuard,
					},
					{
						name: 'PromotionThankYouPageMobile',
						path: 'dziekujemy',
						component: () => import('@customer/profile/promotion/PromotionThankYouPageMobile.vue'),
					},
				],
			},
			{
				path: 'informacje',
				name: 'CustomerProfileBasicInfo',
				component: () => import('@customer/profile/BasicInfoPage.vue'),
			},
			{
				path: 'dane-kontaktowe',
				name: 'CustomerProfileContactInfo',
				component: () => import('@customer/profile/ContactInfoPage.vue'),
			},
			{
				path: 'opis',
				name: 'CustomerProfileDescription',
				component: () => import('@customer/profile/DescriptionPage.vue'),
			},
			{
				path: 'galeria-zdjec',
				name: 'CustomerProfileGallery',
				component: () => import('@customer/profile/GalleryPage.vue'),
			},
			{
				path: 'opinie',
				name: 'CustomerProfileReviews',
				component: () => import('@customer/profile/reviews/ReviewsPage.vue'),
			},
			{
				path: 'oferty',
				name: 'CustomerProfileOffers',
				component: () => import('@customer/profile/OffersPage.vue'),
			},
			{
				path: 'oferty/dodaj-edytuj',
				name: 'CustomerProfileOffersAddEdit',
				component: () => import('@customer/profile/offers-page/OffersAddEdit.vue'),
				beforeEnter: offersChildGuard,
			},
			{
				path: 'certyfikaty',
				name: 'CustomerProfileCertificates',
				component: () => import('@customer/profile/certificates/CertificatesPage.vue'),
				children: [
					{
						path: 'polecaja-nas',
						name: 'CustomerProfileCertificatesPageRecommended',
						component: () => import('@customer/profile/certificates/certificates-page/CertificatesPageRecommended.vue'),
					},
					{
						path: 'sprawdzona-firma',
						name: 'CustomerProfileCertificatesPageVerified',
						component: () => import('@customer/profile/certificates/certificates-page/CertificatesPageVerified.vue'),
					},
					{
						path: 'profesjonalny-sprzedawca',
						name: 'CustomerProfileCertificatesPageProfessional',
						component: () => import('@customer/profile/certificates/certificates-page/CertificatesPageProfessional.vue'),
					},
					{
						path: 'ekspert-oferteo',
						name: 'CustomerProfileCertificatesPageExpert',
						component: () => import('@customer/profile/certificates/certificates-page/CertificatesPageExpert.vue'),
					},
					{
						path: 'promuj-firme',
						name: 'CustomerProfileCertificatesPagePromotion',
						component: () => import('@customer/profile/certificates/certificates-page/CertificatesPagePromotion.vue'),
					},
				],
			},
			{
				path: 'certyfikaty/odznaki',
				name: 'CustomerProfileCertificatesBadge',
				component: () => import('@customer/profile/CertificatesBadgePage.vue'),
			},
			{
				path: 'certyfikaty/naklejki',
				name: 'CustomerProfileCertificatesBadge',
				component: () => import('@customer/profile/CertificatesBadgePage.vue'),
			},
			{
				path: 'program-partnerski',
				name: 'CustomerProfilePartnership',
				component: () => import('@customer/profile/PartnershipPage.vue'),
			},
		],
	},
	{
		path: '/konto/profil/:catchAll(.*)',
		redirect: '/konto/profil',
	},
] as RouteRecordRaw[];
